module.exports = __webpack_public_path__ + "static/media/taoshan_package.f145c7d1.webp";